import { PersistDataEnum } from "@utilities/enums";
import { decryptData, encryptData } from "@utilities/functions";
import { User } from "@utilities/types";
import { createContext, FC, PropsWithChildren, useEffect, useState } from "react";

interface IUserContext {
    user: User | null;
    setUser: React.Dispatch<User | null>;
    temporaryToken: string;
    setTemporaryToken: React.Dispatch<string>;
    collaborators: User[];
    setCollaborators: React.Dispatch<React.SetStateAction<User[]>>;
}

export const UserContext = createContext<IUserContext>({
    user: null,
    setUser: () => {},
    temporaryToken: '',
    setTemporaryToken: () => {},
    collaborators: [],
    setCollaborators: () => {},
});

export const UserContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [user, setUser] = useState<User | null>(() => {
        const stored = localStorage.getItem(PersistDataEnum.USER);
        return stored ? JSON.parse(decryptData(stored)) : null;
    });
    const [temporaryToken, setTemporaryToken] = useState<string>(() => {
        const stored = localStorage.getItem(PersistDataEnum.TEMPORARY_TOKEN);
        return stored ? JSON.parse(decryptData(stored)) : '';
    });
    const [collaborators, setCollaborators] = useState<User[]>(() => {
        const stored = localStorage.getItem(PersistDataEnum.COLLABORATORS);
        return stored ? JSON.parse(decryptData(stored)) : [];
    });

    useEffect(() => {
        const formattedUser = user ? encryptData(user) : '';
        localStorage.setItem(PersistDataEnum.USER, formattedUser);
    }, [user]);

    useEffect(() => {
        const formattedTmpToken = temporaryToken ? encryptData(temporaryToken) : '';
        if (user?.token) {
            localStorage.removeItem(PersistDataEnum.TEMPORARY_TOKEN)
        } else {
            localStorage.setItem(PersistDataEnum.TEMPORARY_TOKEN, formattedTmpToken);
        }

    }, [temporaryToken, user]);

    useEffect(() => {
        const formattedUser = collaborators.length > 0 ? encryptData(collaborators) : '';
        localStorage.setItem(PersistDataEnum.COLLABORATORS, formattedUser);
    }, [collaborators]);
    
    return (
        <UserContext.Provider value={{
            user, setUser,
            temporaryToken, setTemporaryToken,
            collaborators, setCollaborators
        }}>
            {children}
        </UserContext.Provider>
    );
};
